<a
  [attr.aria-label]="
    'miniCart.item' | cxTranslate: { count: quantity$ | async }
  "
  [routerLink]="{ cxRoute: 'cart' } | cxUrl"
>
  <cx-icon [type]="iconTypes.CART"></cx-icon>

  <span class="count">
    {{ 'miniCart.count' | cxTranslate: { count: quantity$ | async } }}
    {{ 'uigCartItems.products' | cxTranslate }}
  </span>

  <span class="total">
    {{ 'miniCart.total' | cxTranslate: { total: total$ | async } }}
  </span>
</a>
